var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarbon = function SvgCarbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#f5b90d",
    "data-name": "Ellipse 319"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M60.19 38.74a12.67 12.67 0 0 0-24-8.07c-.11.32-.2.65-.28 1a9.8 9.8 0 0 0-10.8 7.22 9.8 9.8 0 0 0-5.43 18.84 10 10 0 0 0 2.72.38H58a9.8 9.8 0 0 0 2.2-19.35z",
    "data-name": "Path 2348"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.08 45.51a4.69 4.69 0 0 1 4.65-4.73 4.52 4.52 0 0 1 3.55 1.66l-1 .82a3.19 3.19 0 0 0-2.52-1.19 3.44 3.44 0 0 0 0 6.88 3.27 3.27 0 0 0 2.52-1.19l1 .81a4.49 4.49 0 0 1-3.55 1.66 4.68 4.68 0 0 1-4.68-4.69z",
    className: "cls-3",
    "data-name": "Path 2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.22 45.51a4.69 4.69 0 1 1 0 .06zm8 0A3.3 3.3 0 1 0 42.87 49a3.35 3.35 0 0 0 3.31-3.39v-.05z",
    className: "cls-3",
    "data-name": "Path 2350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.47 48.84v1.26h-5.61v-.62l3.29-4a3.38 3.38 0 0 0 .85-1.65 1.34 1.34 0 0 0-1.32-1.36h-.17A1.45 1.45 0 0 0 50 43.79l-1.18-.24a2.58 2.58 0 0 1 2.77-2.31 2.52 2.52 0 0 1 2.77 2.28 1.71 1.71 0 0 1 0 .32 3.77 3.77 0 0 1-1 2.26L51 48.84z",
    className: "cls-3",
    "data-name": "Path 2351"
  })))))));
};
export default SvgCarbon;